function bindLuckyBallsDrawRound(roundId) {
    var r = roundId
        || window['globalCurrentGameId']
        || (window['state'] && window['state'].roundid_today)
        || (window['responseHandler'] && window['responseHandler'].getGame && window['responseHandler'].getGame.ID_Today)
        || '';
    if (r === undefined || r === null || String(r) === '') {
        return;
    }
    r = String(r);
    window['currentDrawRoundToday'] = r;
    window['todayRoundId'] = r;
    window['drawnNumbersForRound'] = r;
}
window['bindLuckyBallsDrawRound'] = bindLuckyBallsDrawRound;

classGame = function() {

    var self = this;

    this.extractBall = function(ballNumber) {

        if (window['drawnBalls'] >= 35) {
            console.log('All balls drawn!');
        } else {
            bindLuckyBallsDrawRound();
            scene.elementsPriority.bigBall.setBall(ballNumber);
            scene.elementsPriority.bigBall.startAnimation();
            scene.elements['point_' + window['drawnBalls']].appendBall(ballNumber);

            // triger event to update tickets
            var ticketsEvent = new CustomEvent("update_tickets");
            window.dispatchEvent(ticketsEvent);

        }
    }

    this.initialize = function() {

        // Count drawn balls
        window['drawnBalls'] = 0;
        // contains array of drawn numbers
        window['drawnNumbers'] = new Array();
        window['drawnOddBalls'] = 0;
        window['drawnEvenBalls'] = 0;
        window['shownColorBetting'] = 0;
        window['bonusNumbers'] = new Array();

        drawnColors = {
            red: 0,
            blue: 0,
            green: 0,
            brown: 0,
            yellow: 0,
            black: 0,
            orange: 0,
            purple: 0
        }

        if (typeof state.balls !== 'undefined') {
            for (var id in state.balls) {
                scene.elements['point_' + id].appendBall(state.balls[id]);
            }
        }

        // show bonus numbers
        scene.add(new classText()
                .setX(703)
                .setY(435)
                .setFontSize('11px')
                .setFontFamily('FuturaHeavy')
                .setText(bonusNumbers),
                'bonus_numbers');

        // show jackpot code
        scene.add(new classText()
                .setX(514)
                .setY(95)
                .setFontSize('19px')
                .setFontFamily('FuturaHeavy')
                .setColor('#FFFF8A')
                .setText(state.GameJackPotCode),
                'jackpotCode'
                );

        scene.add(new classText()
                .setX(192)
                .setY(95)
                .setFontSize('19px')
                .setFontFamily('FuturaHeavy')
                .setColor('#FFFF8A')
                .setText(state.roundid_today),
                'roundNo'
                );

        bindLuckyBallsDrawRound(state.roundid_today);

        // triger event to update tickets
        var ticketsEvent = new CustomEvent("update_tickets");
        window.dispatchEvent(ticketsEvent);
    }

    this.reset = function() {

        state = {};

        // count drawn balls
        drawnBalls = 0;
        // contains array of drawn numbers
        window['drawnNumbers'] = new Array();
        drawnOddBalls = 0;
        drawnEvenBalls = 0;
        shownColorBetting = 0;
        bonusNumbers = new Array();

        drawnColors = {
            red: 0,
            blue: 0,
            green: 0,
            brown: 0,
            yellow: 0,
            black: 0,
            orange: 0,
            purple: 0
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/game.js
// module id = 871
// module chunks = 0